import { AlignmentPointType, } from "../../core/alignment/interface";
/** Picks one kind per point; curve points win over station so a merged point is tracked by id in both 2D and 3D. */
function resolveMarkerKind(pointType) {
    if (pointType.includes(AlignmentPointType.BEGIN_CURVE_POINT)) {
        return "beginCurve";
    }
    if (pointType.includes(AlignmentPointType.END_CURVE_POINT)) {
        return "endCurve";
    }
    if (pointType.includes(AlignmentPointType.STATION_POINT)) {
        return "station";
    }
    return undefined;
}
export function toSectionMarkers(centerLinePoints) {
    const markers = [];
    for (const point of centerLinePoints) {
        const kind = resolveMarkerKind(point.pointType);
        if (!kind)
            continue;
        markers.push({
            id: point.id,
            kind,
            label: point.label,
            distanceFromStart: point.distanceFromStart,
        });
    }
    return markers;
}
//# sourceMappingURL=alignment-section-marker-adapter.js.map